<template>
  <div>
    <div class="pb-32 bg-gray-800">
      <Navbar :user="user" />

      <header v-if="title" class="py-10">
        <h2 class="text-2xl font-bold text-center text-white sm:text-3xl lg:text-left lg:ml-32">
          {{ title }}
        </h2>
      </header>
      <div v-else class="py-6"></div>
    </div>

    <main class="-mt-40">
      <div class="px-4 pb-12 mx-auto max-w-8xl sm:px-6 lg:px-8">
        <slot></slot>
      </div>
    </main>
  </div>
</template>

<script>
import Navbar from './Navbar'

export default {
  props: ['title', 'user'],

  components: { Navbar },
}
</script>
